export default __webpack_public_path__ + "static/media/8@2x.2f8946e7.png";